<form ngNoForm action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
  <input type=hidden name='captcha_settings' value='{"keyname":"reCAPTCHA","fallback":"true","orgId":"00D0Y000001IuXb","ts":""}'>
  <input type=hidden name="oid" value="00D0Y000001IuXb">
  <input type=hidden name="retURL" value="https://city-sightseeing.com">
  <div class="only-desktop">
    <div class="contact-form--first contact-form__details">
      <div class="contact-form__container">
        <label class="contact-form__label contact-form__label--required" for="first_name">{{'NAME' | translate}}</label>
        <input class="contact-form__input" id="first_name" maxlength="40" size="20" type="text" required />
      </div>
      <div class="contact-form__container">
        <label class="contact-form__label" for="last_name">{{'LASTNAME' | translate}}</label>
        <input class="contact-form__input" id="last_name" maxlength="80" size="20" type="text" />
      </div>
    </div>
    <div class="contact-form--normal contact-form__details">
      <div class="contact-form__container">
        <label class="contact-form__label contact-form__label--required" for="email">E-mail</label>
        <input class="contact-form__input" id="email" maxlength="80" size="20" type="email" required />
      </div>
      <div class="contact-form__container"></div>
    </div>
    <div class="contact-form--normal contact-form__details">
      <div class="contact-form__container">
        <label class="contact-form__label" for="topic">{{'CONTACT_SUBJECT' | translate}}</label>
        <input class="contact-form__input" id="topic" maxlength="80" name="email" size="20" type="text" />
      </div>
      <div class="contact-form__container"></div>
    </div>
    <div class="contact-form--normal contact-form--last">
      <label class="contact-form__label contact-form__label--required" for="message">{{'CONTACT_MESSAGE' | translate}}</label>
      <textarea class="contact-form__text-area" id="message" maxlength="280" name="text" size="20" type="text" required></textarea>
    </div>
    <div class="contact-form--info-req">
      <span>*</span><span>{{'CONTACT_REQUIRED' | translate}}</span>
    </div>
    <div class="container-alone">
      <div class="captcha">
        <re-captcha (captchaResponse)="handleCorrectCaptcha($event)" *ngIf="!isNode" site_key="6LeaeCEUAAAAAKvjjyKL_92Vb6vA8lmOYL9HLNnt"></re-captcha>
      </div>
    </div>
  </div>
  <div class="only-mobile">
    <div class="contact-form--mobile">
      <div class="contact-form__container">
        <label class="contact-form__label contact-form__label--required" for="first_name">{{'NAME' | translate}}</label>
        <input class="contact-form__input" id="first_name" maxlength="40" size="20" type="text" required />
      </div>
      <div class="contact-form__container">
        <label class="contact-form__label" for="last_name">{{'LASTNAME' | translate}}</label>
        <input class="contact-form__input" id="last_name" maxlength="80" size="20" type="text" />
      </div>
      <div class="contact-form__container">
        <label class="contact-form__label contact-form__label--required" for="email">E-mail</label>
        <input class="contact-form__input" id="email" maxlength="80" size="20" type="email" required />
      </div>
      <div class="contact-form__container">
        <label class="contact-form__label" for="topic">{{'CONTACT_SUBJECT' | translate}}</label>
        <input class="contact-form__input" id="topic" maxlength="80" name="email" size="20" type="text" />
      </div>
      <div class="contact-form--normal contact-form--last">
        <label class="contact-form__label contact-form__label--required" for="message">{{'CONTACT_MESSAGE' | translate}}</label>
        <textarea class="contact-form__text-area" id="message" maxlength="280" name="text" size="20" type="text"
          required></textarea>
      </div>
      <div class="contact-form--info-req">
        <span>*</span><span>{{'CONTACT_REQUIRED' | translate}}</span>
      </div>
      <div class="container-alone">
        <div class="captcha">
          <re-captcha (captchaResponse)="handleCorrectCaptcha($event)" *ngIf="!isNode" site_key="6LeaeCEUAAAAAKvjjyKL_92Vb6vA8lmOYL9HLNnt"></re-captcha>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-form__send">
    <button class="contact-form__btn" [disabled]="isDisabled" *ngIf="!isNode" id="sendtosf" type="submit">{{'CONTACT_SEND' | translate}}</button>
  </div>
</form>